import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-check",
  "use": "icon-s-check-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-check\"><path fill-rule=\"evenodd\" d=\"M20.089 3 6.801 16.199 1.41 10.835 1.0658141e-14 12.254 6.799 19.019 21.499 4.419z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol